import * as React from 'react';
const FilterHeader = (props) => {
    return (React.createElement("div", { className: "filter__section filter__section--header" },
        React.createElement("div", { className: "filter__content" }, props.children)));
};
export { FilterHeader as default };
